import ForumCard from "./ForumCard";

export default ForumCard;
